/*
 * custom.js - codice su misura Dalle Piane, portato su Prestige 11 il 12-09-2026.
 *
 * Su Prestige 5 questo file era scritto in jQuery e serviva a due cose: aprire
 * l'elenco dei paesi nell'header e gestire la spunta della confezione regalo.
 * L'11-09-2026 e' stato riscritto in JavaScript nativo e jQuery e' stato tolto
 * dal tema. Prestige 11 non usa jQuery, quindi qui resta la versione nativa.
 *
 * Contiene la confezione regalo e il messaggio di auguri. Il selettore paese
 * arrivera' quando si ricostruira' l'header.
 *
 * 20-09-2026 - TOLTO IL COLLEGAMENTO ALLA TABELLA TAGLIE.
 * Creava un pulsante accanto all'etichetta della taglia che faceva clic su
 * quello dell'app Best Fit Size Charts, e nascondeva l'originale col CSS.
 * L'app non si usa piu': la tabella taglie la fa Prestige da solo, dal setting
 * size_chart_page del blocco variant_picker, che punta alla pagina
 * trova-tua-taglia-dalle-piane-cashmere. Senza l'app quel codice non faceva
 * piu' niente. In assets/custom.css restano le regole .dpc-taglie e
 * .dpc-taglie-spostata, inerti: si tolgono la prossima volta che si apre quel
 * file.
 *
 * 17-09-2026 - TOLTO IL "LEGGI TUTTO".
 * Serviva quando le descrizioni erano lunghe: le tagliava in altezza e le
 * apriva con un clic. Le descrizioni sono state riscritte tutte corte, quindi
 * il taglio era rimasto a fare la guardia a un testo che ormai ci sta dentro
 * da solo, con il suo costo: un bottone da creare, una misura a ogni
 * ridimensionamento della finestra e una manciata di regole CSS. Via da qui e
 * via da custom.css.
 *
 * NOTA STORICA (13-09-2026), utile se un domani la chat sparisce.
 * Per qualche ora qui c'e' stata una rete di sicurezza che caricava lo snippet
 * Zendesk se dopo tre secondi non era ancora arrivato. Serviva perche' la chat
 * non la caricava ne' il tema ne' l'app embed (che risultava acceso ma non
 * produceva niente): la caricava un vecchio script tag a livello negozio che
 * puntava a /t/17/assets/zendesk-embeddable.js, cioe' un file dentro gli asset
 * di un tema del 2022 - e cancellando quel tema la chat sarebbe sparita da
 * tutto il negozio senza un errore.
 * Reinstallando l'app Zendesk l'estensione ha ripreso a funzionare: ora il
 * blocco app stampa lui lo snippet, su questo tema e anche su quello
 * pubblicato, quindi la rete e' diventata codice morto ed e' stata tolta.
 * Se un giorno la chat non compare piu', il primo posto dove guardare e'
 * l'app embed Zendesk nelle impostazioni del tema.
 */

(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DPC = (window.themeVariables && window.themeVariables.dpc) || {};

  /*
   * Ascolto delegato sul documento: le righe del carrello vengono ridisegnate
   * dopo ogni modifica, quindi un listener attaccato direttamente alle caselle
   * si perderebbe al primo aggiornamento. Vale sia per la pagina carrello sia
   * per il carrello a tendina.
   */
  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest('.gift-wrap__checkbox');

    if (checkbox === null) {
      return;
    }

    var wanted = checkbox.checked;
    checkbox.disabled = true;

    var action = wanted
      ? addGiftWrap(checkbox.dataset.giftVariant, checkbox.dataset.targetVariant, checkbox.dataset.targetTitle)
      : removeGiftWrap(checkbox.dataset.targetVariant);

    action
      .then(function () {
        refreshCart();
      })
      .catch(function (error) {
        // Se la chiamata fallisce si riporta la casella allo stato precedente,
        // altrimenti mostrerebbe una confezione che nel carrello non c'e'.
        console.error('[confezione regalo]', error);
        checkbox.checked = !wanted;
        checkbox.disabled = false;
      });
  });

  /*
   * Come aggiorna Prestige 11 dopo una modifica al carrello.
   *
   * cart:refresh e' ascoltato dal contatore, dal pallino e dal carrello a
   * tendina, ma NON dalla sezione della pagina carrello, che si aggiorna solo
   * via cart:change con il carrello gia' in mano oppure con il rendering delle
   * sezioni. Verificato dentro theme.js della 11.4.0: nel codice del codice
   * sconto il tema fa esattamente questo, cioe' emette cart:refresh e, se si
   * trova sulla pagina carrello, ricarica. Qui si fa lo stesso, per non
   * lasciare la casella della pagina spuntata su un carrello che nel frattempo
   * e' cambiato.
   */
  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    var pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;

    if (pageType === 'cart') {
      window.location.reload();
    }
  }

  function addGiftWrap(giftVariantId, targetVariantId, targetTitle) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(giftVariantId),
            quantity: 1,
            properties: {
              _variant_id: String(targetVariantId),
              'Confezione regalo per': targetTitle
            }
          }
        ]
      })
    }).then(checkResponse);
  }

  function removeGiftWrap(targetVariantId) {
    return fetch(root + 'cart.js')
      .then(checkResponse)
      .then(function (cart) {
        var line = cart.items.filter(function (item) {
          return item.properties && String(item.properties._variant_id) === String(targetVariantId);
        })[0];

        if (!line) {
          return null; // gia' rimossa altrove: non e' un errore
        }

        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(checkResponse);
      });
  }

  function checkResponse(response) {
    if (!response.ok) {
      return response.text().then(function (body) {
        throw new Error(response.status + ' ' + body.slice(0, 200));
      });
    }

    return response.json();
  }

  /* ----------------------------------------------------------------
   * 15-09-2026 - Trustpilot: ravvivare il widget dopo il cambio variante.
   *
   * Il sintomo, visto cambiando colore su una scheda prodotto: le
   * stelline sparivano e tornavano solo ricaricando la pagina.
   *
   * Perche'. Quando si cambia variante Prestige non ritocca qualche
   * pezzo: si fa restituire da Shopify l'intera colonna informazioni e
   * ne riscrive il contenuto. Il contenitore Trustpilot che c'era,
   * iframe compreso, viene buttato via e al suo posto ne arriva uno
   * nuovo, vuoto. Il caricatore di Trustpilot pero' cerca i widget UNA
   * VOLTA SOLA, al caricamento della pagina, e non sta a guardare se ne
   * compaiono altri: il contenitore nuovo restava vuoto per sempre.
   *
   * La cura. Trustpilot espone loadFromElement(elemento, true) proprio
   * per i widget inseriti dopo il caricamento; il secondo argomento gli
   * dice di rileggere gli attributi data-* dall'elemento invece di
   * usare quelli che ha in memoria.
   *
   * Si ravviva SOLO chi non ha gia' un iframe dentro: altrimenti a ogni
   * mutazione si ricaricherebbero widget gia' funzionanti, con uno
   * sfarfallio e chiamate di rete per niente.
   *
   * NOTA (17-09-2026): Klarna, che sta nella stessa colonna, NON ha
   * questo problema - verificato su registrazione dello schermo, al
   * cambio colore il suo riquadro resta al suo posto gia' disegnato.
   * Il suo difetto e' un altro e si risolve tutto in custom.css, nello
   * spazio riservato: qui non serve niente.
   * ---------------------------------------------------------------- */

  var timerTrustpilot = null;

  function zonaProdotto() {
    var info = document.querySelector('.product-info');

    if (info === null) {
      return null; // non siamo su una scheda prodotto
    }

    // Si osserva la SEZIONE che contiene la colonna, non la colonna: la
    // sezione non viene sostituita quando si cambia variante, ne viene
    // riscritto il contenuto. Agganciarsi a .product-info significa
    // ritrovarsi, dopo il primo cambio colore, un osservatore attaccato a
    // un nodo ormai staccato dalla pagina, che non segnala piu' niente.
    return info.closest('[id^="shopify-section-"]') || document.body;
  }

  function ravvivaTrustpilot() {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') {
      return; // il caricatore dell'app non e' (ancora) in pagina
    }

    var widget = document.querySelectorAll('.trustpilot-widget');

    for (var i = 0; i < widget.length; i++) {
      if (widget[i].querySelector('iframe') === null) {
        window.Trustpilot.loadFromElement(widget[i], true);
      }
    }
  }

  function chiediRavvivamento() {
    clearTimeout(timerTrustpilot);
    timerTrustpilot = setTimeout(ravvivaTrustpilot, 150);
  }

  function osservaTrustpilot() {
    var zona = zonaProdotto();

    if (zona === null) {
      return;
    }

    new MutationObserver(chiediRavvivamento).observe(zona, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', osservaTrustpilot);
  } else {
    osservaTrustpilot();
  }

  // L'editor del tema ridisegna la sezione a ogni modifica: senza questo,
  // lavorando nell'editor le stelline sparirebbero al primo ritocco.
  document.addEventListener('shopify:section:load', chiediRavvivamento);

  /* ----------------------------------------------------------------
   * 14-09-2026 - Confezione regalo rimasta orfana.
   *
   * Ogni riga "confezione regalo" porta la proprieta' nascosta
   * _variant_id con l'id della variante a cui e' agganciata. Se il
   * cliente toglie il capo ma lascia la confezione, nel carrello
   * resterebbe una scatola da sola: non la vendiamo, e non ha
   * nemmeno senso spedirla.
   *
   * Qui, dopo ogni modifica al carrello, si rileggono le righe e si
   * tolgono quelle il cui capo non c'e' piu'. Vale anche per la
   * quantita' portata a zero, che per Shopify e' una rimozione.
   *
   * Due paracadute: un interruttore per non rientrare mentre la
   * pulizia e' in corso, e un ricaricamento al massimo per volta,
   * cosi' un caso imprevisto non manda la pagina carrello in un
   * ciclo di ricariche.
   * ---------------------------------------------------------------- */
  var puliziaInCorso = false;
  var giaRicaricato = false;

  function pulisciConfezioniOrfane() {
    if (puliziaInCorso) {
      return Promise.resolve(false);
    }

    puliziaInCorso = true;

    return fetch(root + 'cart.js')
      .then(checkResponse)
      .then(function (cart) {
        var presenti = {};

        cart.items.forEach(function (item) {
          presenti[String(item.variant_id)] = true;
        });

        var orfane = cart.items.filter(function (item) {
          var legame = item.properties && item.properties._variant_id;
          return legame && !presenti[String(legame)];
        });

        if (orfane.length === 0) {
          return false;
        }

        // una alla volta: /cart/change.js rinumera le chiavi a ogni scrittura
        return orfane
          .reduce(function (catena, riga) {
            return catena.then(function () {
              return fetch(root + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: riga.key, quantity: 0 })
              }).then(checkResponse);
            });
          }, Promise.resolve())
          .then(function () {
            return true;
          });
      })
      .then(function (rimosse) {
        puliziaInCorso = false;

        if (rimosse) {
          var pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;

          if (pageType === 'cart' && !giaRicaricato) {
            giaRicaricato = true;
            window.location.reload();
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
        }

        return rimosse;
      })
      .catch(function (error) {
        puliziaInCorso = false;
        console.error('[confezione regalo] pulizia', error);
        return false;
      });
  }

  document.documentElement.addEventListener('cart:refresh', function () {
    pulisciConfezioniOrfane();
  });

  document.documentElement.addEventListener('cart:change', function () {
    pulisciConfezioniOrfane();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pulisciConfezioniOrfane);
  } else {
    pulisciConfezioniOrfane();
  }

  /* ----------------------------------------------------------------
   * 14-09-2026 - Messaggio di auguri.
   *
   * Il testo viene salvato come proprieta' "Messaggio di auguri"
   * SULLA RIGA DELLA CONFEZIONE: cosi' se la confezione viene tolta
   * sparisce anche il messaggio, e in admin si legge accanto alla
   * confezione a cui appartiene.
   *
   * 17-09-2026 - NON PIU' SOLO SULLA RIGA DELLA CONFEZIONE.
   * Sui capi che la scatola ce l'hanno gia' dentro (le due copertine
   * neonato G031 e A392) una riga confezione non esiste, e il
   * messaggio si attacca alla riga del capo. Qui dentro non cambia
   * niente: su quale riga scrivere arriva sempre da data-line-key, ed
   * e' gift-wrap.liquid a deciderlo. Cambia invece come si ritrova la
   * riga DOPO il salvataggio - vedi piu' sotto, e' il punto delicato.
   *
   * Si salva quando il campo perde il fuoco, non a ogni tasto: sono
   * chiamate di rete, non vale la pena farne una per lettera.
   *
   * ATTENZIONE: /cart/change.js CAMBIA LA CHIAVE della riga quando ne
   * cambiano le proprieta'. Dopo il salvataggio bisogna quindi
   * rileggere la nuova chiave dalla risposta, altrimenti il secondo
   * salvataggio scrive su una riga che non esiste piu'. E' il motivo
   * per cui qui non si ricarica la pagina: il totale non cambia, e
   * una ricarica a ogni messaggio scritto sarebbe fastidiosa.
   *
   * Sulla pagina carrello lo snippet esce due volte per la stessa
   * riga (pagina piu' tendina), quindi dopo il salvataggio si
   * allineano anche le altre caselle che puntano alla stessa riga.
   * ---------------------------------------------------------------- */
  function campiDellaStessaRiga(chiave) {
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-gift-message]'))
      .filter(function (campo) {
        return campo.dataset.lineKey === chiave;
      });
  }

  function aggiornaContatore(campo) {
    var piede = campo.parentElement.querySelector('[data-gift-message-count]');

    if (piede) {
      piede.textContent = campo.value.length + '/' + (campo.maxLength > 0 ? campo.maxLength : 200);
    }
  }

  function mostraStato(campo, testo) {
    var stato = campo.parentElement.querySelector('[data-gift-message-status]');

    if (!stato) {
      return;
    }

    stato.textContent = testo;

    if (testo) {
      window.setTimeout(function () {
        stato.textContent = '';
      }, 2500);
    }
  }

  function salvaMessaggio(campo) {
    var chiave = campo.dataset.lineKey;
    var testo = campo.value.trim();

    if (!chiave || campo.dataset.ultimoSalvato === testo) {
      return;
    }

    campo.dataset.ultimoSalvato = testo;

    fetch(root + 'cart.js')
      .then(checkResponse)
      .then(function (cart) {
        var riga = cart.items.filter(function (item) {
          return item.key === chiave;
        })[0];

        if (!riga) {
          return null;
        }

        // si riscrivono TUTTE le proprieta': change.js sostituisce il gruppo,
        // non lo aggiorna, quindi omettere _variant_id spezzerebbe il legame
        var proprieta = {};

        Object.keys(riga.properties || {}).forEach(function (nome) {
          proprieta[nome] = riga.properties[nome];
        });

        if (testo) {
          proprieta['Messaggio di auguri'] = testo;
        } else {
          delete proprieta['Messaggio di auguri'];
        }

        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: chiave, properties: proprieta })
        }).then(checkResponse);
      })
      .then(function (cart) {
        if (!cart) {
          return;
        }

        /*
         * 17-09-2026 - LA RIGA SI RITROVA DALLA VARIANTE, NON DALLA VECCHIA CHIAVE.
         *
         * change.js cambia la chiave a ogni scrittura di proprieta'. Il codice
         * di prima cercava il legame _variant_id partendo dalla chiave VECCHIA,
         * che nel carrello appena tornato non esiste piu': legame restava
         * sempre null. Finche' si scrive un testo il difetto non si vede,
         * perche' basta il confronto sul testo; ma CANCELLANDO il messaggio non
         * si trovava piu' niente, il campo restava agganciato a una chiave
         * morta e il messaggio scritto subito dopo non si salvava, senza
         * nessun errore a schermo.
         *
         * Ora la riga si riconosce da quello che non cambia, cioe' la variante.
         * Il confronto sul legame serve a distinguere due righe confezione
         * della stessa scatola agganciate a capi diversi; sulle righe normali,
         * dove il legame non c'e', si pretende che non ci sia, altrimenti una
         * copertina potrebbe farsi passare per la confezione di qualcun altro.
         */
        var variante = campo.dataset.lineVariant;
        var legame = campo.dataset.lineTarget;

        var nuova = cart.items.filter(function (item) {
          var p = item.properties || {};

          if (variante && String(item.variant_id) !== String(variante)) {
            return false;
          }

          if (legame) {
            if (String(p._variant_id || '') !== String(legame)) {
              return false;
            }
          } else if (p._variant_id) {
            return false;
          }

          return testo ? p['Messaggio di auguri'] === testo : !p['Messaggio di auguri'];
        })[0];

        if (nuova) {
          campiDellaStessaRiga(chiave).forEach(function (altro) {
            altro.dataset.lineKey = nuova.key;
            if (altro !== campo) {
              altro.value = testo;
              aggiornaContatore(altro);
            }
          });
        }

        mostraStato(campo, DPC.messaggioSalvato || 'Messaggio salvato');
      })
      .catch(function (error) {
        console.error('[messaggio di auguri]', error);
        campo.dataset.ultimoSalvato = '';
        mostraStato(campo, DPC.messaggioErrore || 'Non sono riuscito a salvare, riprova');
      });
  }

  document.addEventListener('input', function (event) {
    var campo = event.target.closest('[data-gift-message]');

    if (campo) {
      aggiornaContatore(campo);
    }
  });

  document.addEventListener(
    'blur',
    function (event) {
      var campo = event.target.closest('[data-gift-message]');

      if (campo) {
        salvaMessaggio(campo);
      }
    },
    true
  );
})();
